import { createSlice } from "@reduxjs/toolkit";
import {
  toGetDashboard,
  toGetProjects,
  toGetProjectDetails,
  toGetProjectOpertaions,
  toGetProjectOpertaionsStatus,
  toGetInitiativesSummary,
  toGetInitiativesAnalytics,
  toGetInitiativeDetails,
} from "../actions/dashboard.actions";

const initialState = {
  dashboardData: {
    list: [],
    status: "idle",
  } as any,
  projects: {
    list: [],
    status: "idle",
  } as any,
  projectDetails: {
    list: [],
    status: "idle",
  } as any,
  projectOpertaions: {
    list: [],
    status: "idle",
  } as any,
  projectOpertaionsStatus: {
    list: [],
    status: "idle",
  } as any,
  initiatives: {
    list: [],
    status: "idle",
  } as any,
  initiativesAnalytics: {
    list: [],
    status: "idle",
  } as any,
  initiativeDetails: {
    list: [],
    status: "idle",
  } as any,
  selectedView: "projects" as string,
  loading: false,
  error: null as unknown | null,
};
export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    setSelectedView: (state, action) => {
      state.selectedView = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(toGetDashboard.pending, (state) => {
      state.dashboardData = { list: [], status: "idle" };
    });
    builder.addCase(toGetDashboard.fulfilled, (state, action) => {
      state.dashboardData = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetDashboard.rejected, (state, action) => {
      state.dashboardData = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get all projects
    builder.addCase(toGetProjects.pending, (state) => {
      state.projects = { list: [], status: "idle" };
    });
    builder.addCase(toGetProjects.fulfilled, (state, action) => {
      state.projects = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetProjects.rejected, (state, action) => {
      state.projects = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get project details
    builder.addCase(toGetProjectDetails.pending, (state) => {
      state.projectDetails = { list: [], status: "idle" };
    });
    builder.addCase(toGetProjectDetails.fulfilled, (state, action) => {
      state.projectDetails = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetProjectDetails.rejected, (state, action) => {
      state.projectDetails = { list: [], status: "rejected" };
      state.error = action.payload;
    }); // to get project operations
    builder.addCase(toGetProjectOpertaions.pending, (state) => {
      state.projectOpertaions = { list: [], status: "idle" };
    });
    builder.addCase(toGetProjectOpertaions.fulfilled, (state, action) => {
      state.projectOpertaions = {
        list: action.payload.data.result,
        status: "succedded",
      };
    });
    builder.addCase(toGetProjectOpertaions.rejected, (state, action) => {
      state.projectOpertaions = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get project operation status
    builder.addCase(toGetProjectOpertaionsStatus.pending, (state) => {
      state.projectOpertaionsStatus = { list: [], status: "idle" };
    });
    builder.addCase(toGetProjectOpertaionsStatus.fulfilled, (state, action) => {
      state.projectOpertaionsStatus = {
        list: action.payload.data.result,
        status: "succedded",
      };
    });
    builder.addCase(toGetProjectOpertaionsStatus.rejected, (state, action) => {
      state.projectOpertaionsStatus = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get initiatives summary
    builder.addCase(toGetInitiativesSummary.pending, (state) => {
      state.initiatives = { list: [], status: "idle" };
    });
    builder.addCase(toGetInitiativesSummary.fulfilled, (state, action) => {
      state.initiatives = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetInitiativesSummary.rejected, (state, action) => {
      state.initiatives = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get initiatives analytics
    builder.addCase(toGetInitiativesAnalytics.pending, (state) => {
      state.initiativesAnalytics = { list: [], status: "idle" };
    });
    builder.addCase(toGetInitiativesAnalytics.fulfilled, (state, action) => {
      state.initiativesAnalytics = {
        list: action.payload.data,
        status: "succedded",
      };
    });
    builder.addCase(toGetInitiativesAnalytics.rejected, (state, action) => {
      state.initiativesAnalytics = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get initiative details
    builder.addCase(toGetInitiativeDetails.pending, (state) => {
      state.initiativeDetails = { list: [], status: "idle" };
    });
    builder.addCase(toGetInitiativeDetails.fulfilled, (state, action) => {
      state.initiativeDetails = {
        list: action.payload.data,
        status: "succedded",
      };
    });
    builder.addCase(toGetInitiativeDetails.rejected, (state, action) => {
      state.initiativeDetails = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export const { setSelectedView } = dashboardSlice.actions;
export default dashboardSlice.reducer;
